"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var InformationIcon = function InformationIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 32 32"
  }, props), _react.default.createElement("path", {
    d: "M13 13s2.6-.012 3.025 0c.825.012 1.475.725 1.475 1.55v8.887c0 .825-.65 1.538-1.475 1.55a1.502 1.502 0 0 1-1.525-1.5v-7.5H13c-.825 0-1.5-.675-1.5-1.5s.675-1.488 1.5-1.488zm3-13C7.175 0 0 7.175 0 16s7.175 16 16 16 16-7.175 16-16S24.825 0 16 0zm0 29C8.838 29 3 23.163 3 16S8.838 3 16 3s13 5.838 13 13-5.837 13-13 13zm1.5-20.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17.5 8.5z"
  }));
};

InformationIcon.propTypes = {
  size: _propTypes.number
};
InformationIcon.defaultProps = {
  size: 40
};
var _default = InformationIcon;
exports.default = _default;